module.exports = __webpack_public_path__ + "img/addPlatform.5b62b63b.svg";